import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { EnhancedHeader } from '@/components/EnhancedHeader';
import { LoyaltyProgram } from '@/components/LoyaltyProgram';
import { BettingPools } from '@/components/BettingPools';
import { GamifiedAchievements } from '@/components/GamifiedAchievements';
import { BankrollManager } from '@/components/BankrollManager';
import { OddsAlerts } from '@/components/OddsAlerts';
import { Crown, Users, Trophy, PiggyBank, Bell } from 'lucide-react';

export default function Engagement() {
  return (
    <div className="min-h-screen bg-gradient-dark">
      <EnhancedHeader />
      
      <main className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Engagement Hub</h1>
          <p className="text-muted-foreground">
            Earn rewards, compete with friends, and manage your betting smartly
          </p>
        </div>

        <Tabs defaultValue="loyalty" className="space-y-6">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-5 h-auto">
            <TabsTrigger value="loyalty" className="flex items-center gap-2 py-3">
              <Crown className="h-4 w-4" />
              <span className="hidden sm:inline">Loyalty</span>
            </TabsTrigger>
            <TabsTrigger value="pools" className="flex items-center gap-2 py-3">
              <Users className="h-4 w-4" />
              <span className="hidden sm:inline">Pools</span>
            </TabsTrigger>
            <TabsTrigger value="achievements" className="flex items-center gap-2 py-3">
              <Trophy className="h-4 w-4" />
              <span className="hidden sm:inline">Achievements</span>
            </TabsTrigger>
            <TabsTrigger value="bankroll" className="flex items-center gap-2 py-3">
              <PiggyBank className="h-4 w-4" />
              <span className="hidden sm:inline">Bankroll</span>
            </TabsTrigger>
            <TabsTrigger value="alerts" className="flex items-center gap-2 py-3">
              <Bell className="h-4 w-4" />
              <span className="hidden sm:inline">Alerts</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="loyalty">
            <LoyaltyProgram />
          </TabsContent>

          <TabsContent value="pools">
            <BettingPools />
          </TabsContent>

          <TabsContent value="achievements">
            <GamifiedAchievements />
          </TabsContent>

          <TabsContent value="bankroll">
            <BankrollManager />
          </TabsContent>

          <TabsContent value="alerts">
            <OddsAlerts />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}